import React, { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnimatedLoader from "../../../components/LoaderWrapper";

const Loading = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ minutes: 5, seconds: 0 });
  const [stock, setStock] = useState(17);

  useEffect(() => {
    const target = new Date().getTime() + 5 * 60 * 1000; // 5 minutes from now

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = target - now;

      if (distance <= 0) {
        clearInterval(timer);
        setTime({ minutes: 0, seconds: 0 });

        // ✅ Redirect when countdown ends
        navigate("/qr");
        return;
      }

      setTime({
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  useEffect(() => {
    const stockTimer = setInterval(() => {
      if (stock > 1 && Math.random() > 0.7) {
        setStock((prev) => prev - 1);
      }
    }, 5000);

    return () => clearInterval(stockTimer);
  }, [stock]);

  const formatDigit = (num) => (num < 10 ? `0${num}` : num);

  return (
    <Box
      sx={{
        height: "100vh",
        textAlign: "center",
        fontFamily: "Roboto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#eef2feff",
        px: 2,
      }}
    >
      <Typography
        sx={{ fontSize: { xs: "20px", md: "40px" }, fontWeight: 700 }}
      >
        We are setting up your call center ...
      </Typography>
      <Typography gutterBottom>
        <AnimatedLoader />
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: 4,
            borderRadius: 3,
            color: "white",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            {[
              { label: "Minutes", value: time.minutes },
              { label: "Seconds", value: time.seconds },
            ].map((t, i) => (
              <Grid item xs={6} key={i}>
                <Paper
                  sx={{
                    background: "#272727",
                    p: 2,
                    textAlign: "center",
                    border: "2px solid #333",
                    borderRadius: 2,
                  }}
                  elevation={4}
                >
                  <Typography variant="h4" fontWeight={800} color="white">
                    {formatDigit(t.value)}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ textTransform: "uppercase", color: "#ffffffff" }}
                  >
                    {t.label}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
